import ajax from '@/utils/ajax';

export const head = '/web';
export const reqGetFrontList = (orderNo, status) => ajax(`${head}/v1/logistics/front/list?orderNo=${orderNo}&status=${status}`);// 获取相关订单的物流列表 发货状态 1-待发货 2-已发货
